function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.62 6.16l14 9a1 1 0 0 1 0 1.68l-14 9A1 1 0 0 1 9.08 25V7a1 1 0 0 1 1.54-.84zm.46 2.67v14.34L22.23 16z",
  fill: "#353149",
  "data-name": "Online Screeners"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPkxhbmRpbmcgT25saW5lIFNjcmVlbmVyczwvdGl0bGU+CiAgPGcgZmlsbD0iIzM1MzE0OSIgaWQ9IjAwZWI2NTUwLTkxNDQtNGVjZC05NTY3LTM2OTM2N2M1ODJkYiIgZGF0YS1uYW1lPSJPbmxpbmUgU2NyZWVuZXJzIj4KICAgIDxwYXRoIGQ9Ik0xMC42Miw2LjE2bDE0LDlhMSwxLDAsMCwxLDAsMS42OGwtMTQsOUExLDEsMCwwLDEsOS4wOCwyNVY3QTEsMSwwLDAsMSwxMC42Miw2LjE2Wm0uNDYsMi42N1YyMy4xN0wyMi4yMywxNloiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgComponent as ReactComponent };